import Connection from './connection'
import Store from './store'
import { observable, computed } from 'mobx'
import api from '../api'

export default class IntegrationsStore extends Store {
  @observable available

  @computed get loaded() {
    return this.records !== undefined && this.available !== undefined
  }

  constructor() {
    super(new Connection('integrations'))
  }

  load(...args) {
    const loading = super.load(...args)
    const avail = api.get(`${this.connection.baseUrl}/available`).then(resp => {
      this.available = resp.data
    })

    return Promise.all([loading, avail])
  }

  verify(type, api_key) {
    return api.post(`${this.connection.baseUrl}/verify`, { type, api_key })
      .then(resp => resp.data)
      .catch(() => ({ valid: false }))
  }
}



// WEBPACK FOOTER //
// client/stores/integrations.js